import InternalTemplate from './InternalTemplate';
export default InternalTemplate;